
<ng-container *ngIf="pageData;else loading">
    <div class="tabs fl100">
        <span class="tablinks my_workspace cursor_auto">{{pageData?.name}} Sub Nav</span>
      </div>
      <div class="pageContainer marb20">
      <div class="tabcontent" id="myWorkspace"
      [style.display] = "showMyWorkSpace ? 'block' : 'block'">
      <div class="tabcontainer pageEditor navManager">
        <div class="">
            <div class="allContent">
              <h4>All Topics & Sections</h4>
                <div class="blockContain">
                    <div class="app-nav-listing"
                    pageId="navManager"
                    allApi="all_pages"
                    getDragulaId="left"
                    [showSearch]="true"

                    [isnavLinkIds]="isnavLinkIds"
                    [showPageNav]="true"
                    searchApi="all_pages"
                    metaApi="pages_meta"
                    [parentPageId]="pageData.id" >
                  </div>
                </div>
              </div>
              <div class="livePage">
                  <h4>Section Line-up</h4>
                  <div class="blockContain">
                    <div class="app-nav-listing"
                      pageId="navManager"
                      getDragulaId="right"
                      [showSearch]="false"
                      [showPageNav]="true"
                      [pageNavIds]="pageLinkIds"
                      [isnavLinkIds]="isnavLinkIds"
                      (sendDataToParentfn)="getListIdToParentfn($event)"
                      (sendDeleteIdToParentfn)="getDeleteIdToParentfn($event)"
                      allApi="navManagerlist"
                      putApi="putNavManagerlist"
                      [isLineup]="true">
                    </div>
                  </div>
              </div>
        </div>
        </div>
      </div>
    </div>
    <div class="thirdContainer navManager">
      <div class="storytime blocks">
        <div class="head">Page Timeline</div>
        <div class="form">
            <div class="tiimeline">
                <ng-container *ngFor="let item of listOfHistoryArray.slice(0,5);let i = index">
              <div class="block" >
                <div class="updateby">
                  <p>Date</p>
                  <div class="author">{{item.name}} </div>
                </div>
                <div class="time">{{getVersionDate(+item.historyDate)}}</div>
              </div>
            </ng-container>
            </div>
            <!-- <div id="page_saveBtn">
            <span class="created">
              {{changeFlag ? 'SAVING CHANGES...': 'ALL CHANGES ARE SAVED'}}</span>
          <button type="button"  (click)="savePage(true)" class="green">Publish</button>
        </div> -->
        </div>
      </div>
    </div>
  </ng-container>
   <ng-template #loading>
      <div class="imagepreloader">
          <div class="a" style="--n: 5;">
            <div class="dot dot1" style="--i: 0;"></div>
          <div class="dot dot2" style="--i: 1;"></div>
          <div class="dot dot3" style="--i: 2;"></div>
          <div class="dot dot4" style="--i: 3;"></div>
          </div>
        </div>
    </ng-template>

